import React, { useEffect } from "react";
import Layout from "./src/components/layout";
import { navigate } from "gatsby";

import "./src/styles/global.css";

const LanguageRedirectWrapper = ({ children, location }) => {
  useEffect(() => {
    const { search, pathname } = location;
    const params = new URLSearchParams(search);
    const hl = params.get("hl");

    if (hl && !pathname.startsWith(`/${hl}/`)) {
      let cleanPath = pathname;
      const langPattern = /^\/([a-z]{2})\//;

      if (langPattern.test(pathname)) {
        cleanPath = pathname.replace(langPattern, "/");
      }

      if (cleanPath === "") {
        cleanPath = "/";
      }

      navigate(`/${hl}${cleanPath}`, { replace: true });
    }
  }, [location]);

  return <>{children}</>;
};

export const wrapPageElement = ({ element, props }) => {
  return (
    <LanguageRedirectWrapper {...props}>
      <Layout {...props}>{element}</Layout>
    </LanguageRedirectWrapper>
  );
};

export const onRouteUpdate = () => {
  window.scrollTo(0, 0);
};
